<div *ngIf="!errorWithFile" class="container" (click)="openViewImageModal()">
  <ion-icon class="open-button" name="open-outline" color="#fff"></ion-icon>
  <img *ngIf="path$ | async as url; else loading" [src]="url" />
  <ng-template #loading>
    <ion-skeleton-text animated style="width: 100%; border-radius: 10px;"></ion-skeleton-text>
  </ng-template>
</div>
